import { useUpdateModalStore } from '../../zustandStore/store.update';
import { useAuth } from '../../hooks/useAuth';
import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { PrizeProducts } from '../../interface/interface';

export enum ArchiveType {
  ARCHIVE = 'ARCHIVED',
  ACTIVE = 'ACTIVE'
}

interface ArchiveDialogProps<T> {
  id: string;
  open: boolean;
  endpoint: string;
  callback?: (result: any) => void;
  onClose?: () => void;
  data?: T
}

export const ArchiveDialog = (props: ArchiveDialogProps<PrizeProducts>) => {
  const { id,open,endpoint, callback, onClose, data} = props;
  const { enhancedFetch } = useAuth();

  const status = data?.status;

  const onAccept = async () => {
    const result = await enhancedFetch(endpoint, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        status: status === ArchiveType.ARCHIVE ? ArchiveType.ACTIVE : ArchiveType.ARCHIVE,
      })
    });
    // call the callback function
    onClose && onClose();
    callback && callback(result);
  };
  return (
    <React.Fragment>
      <Dialog
        open={open || false}
        onClose={(e) =>
          onClose()
        }
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">

          {status !== 'ACTIVE' ? 'Unarchive Record' : 'Archive Record'}

        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Do you want to ${status !== 'ACTIVE' ? 'Unarchive' : 'archive'} this record ?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => onClose()}>
            Cancel
          </Button>
          <Button
            onClick={async (e) => {
              await onAccept();
            }}
            autoFocus
          >
            {status !== 'ACTIVE' ? 'Unarchive' : 'Archive'}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
